import * as CSS from 'library/ts/utilities/modules/CSS';
import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
import * as Type from 'library/ts/utilities/modules/Type';
export const replaceElement = (object, string) => {
    if (object.outerHTML) {
        object.outerHTML = string;
    }
    else {
        const tmpObj = document.createElement('div');
        tmpObj.innerHTML = '<!--placeholder-->';
        const ObjParent = object.parentNode;
        ObjParent.replaceChild(tmpObj, object);
        ObjParent.innerHTML = ObjParent.innerHTML.replace('<div><!--placeholder--></div>', string);
    }
};
export const getDeepVal = (object, path) => {
    if (typeof object === TrueType.UNDEFINED || object === null)
        return null;
    const _path = path.split(/[\.\[\]\"\']{1,2}/);
    for (let i = 0; i < _path.length; i++) {
        if (_path[i] === '')
            continue;
        object = object[_path[i]];
        if (typeof object === TrueType.UNDEFINED || object === null)
            return null;
    }
    return object;
};
export const declareNamespace = (ns) => {
    const nsParts = ns.split('.');
    const nsLength = nsParts.length;
    let root = window;
    for (let i = 0; i < nsLength; i++) {
        if (typeof root[nsParts[i]] === TrueType.UNDEFINED)
            root[nsParts[i]] = {};
        root = root[nsParts[i]];
    }
    return getDeepVal(window, ns);
};
export const domParserSupport = (() => {
    if (!window.DOMParser)
        return false;
    const parser = new DOMParser();
    try {
        parser.parseFromString('x', 'text/html');
    }
    catch (err) {
        return false;
    }
    return true;
})();
export const stringToElement = (htmlString) => {
    if (domParserSupport) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return doc.body.firstChild;
    }
    const dom = document.createElement('div');
    dom.innerHTML = htmlString;
    return dom;
};
export const getElementRotation = (element) => {
    const style = window.getComputedStyle(element, null);
    const transform = style.getPropertyValue('-webkit-transform') ||
        style.getPropertyValue('-moz-transform') ||
        style.getPropertyValue('-ms-transform') ||
        style.getPropertyValue('-o-transform') ||
        style.getPropertyValue('transform') ||
        'none';
    let angle = 0;
    if (transform !== 'none') {
        let values = transform.split('(')[1];
        values = values.split(')')[0];
        const valuesSplit = values.split(',');
        const a = parseFloat(valuesSplit[0]);
        const b = parseFloat(valuesSplit[1]);
        const c = parseFloat(valuesSplit[2]);
        const d = parseFloat(valuesSplit[3]);
        const scale = Math.sqrt(a * a + b * b);
        const radians = Math.atan2(b, a);
        angle = Math.round(radians * (180 / Math.PI));
    }
    else {
        angle = 0;
    }
    return angle;
};
export const stringsArrayToElementsArray = (elements = []) => {
    let out = undefined;
    if (Type.isArray(elements)) {
        if (elements.length > 0) {
            out = [];
            for (let i = 0; i < elements.length; i++) {
                out.push(stringToElement(elements[i]));
            }
        }
    }
    return out;
};
export const appendElementsArray = (parent = window, elements = []) => {
    if (Type.isUndefined(elements))
        return;
    if (Type.isArray(elements) === false)
        return;
    for (let i = 0; i < elements.length; i++) {
        if (Type.isElement(elements[i])) {
            parent.appendChild(elements[i]);
        }
    }
};
export const emptyElement = (element, destroy = true) => {
    if (!Type.isElement(element))
        return;
    while (element.firstChild) {
        let removedNode = element.removeChild(element.firstChild);
        if (destroy === true)
            removedNode = undefined;
    }
};
export const cleanElementNode = (node) => {
    for (let n = 0; n < node.childNodes.length; n++) {
        const child = node.childNodes[n];
        if (child.nodeType === 8
            ||
                (child.nodeType === 3 && !/\S/.test(child.nodeValue))) {
            node.removeChild(child);
            n--;
        }
        else if (child.nodeType === 1) {
            cleanElementNode(child);
        }
    }
};
export const getElementsByAttribute = (attribute, context) => {
    const nodeList = (context || document).getElementsByTagName('*');
    const nodeArray = [];
    let iterator = 0;
    const node = null;
    while (node === nodeList[iterator++]) {
        if (node.getAttribute(attribute))
            nodeArray.push(node);
    }
    return nodeArray;
};
export const getElementsByPartialAttribute = (parentElement = document, htmlTag = 'div', attributeName = 'id', value = '') => {
    const query = htmlTag + '[' + attributeName + '^="' + value + '"]';
    return parentElement.querySelectorAll(query);
};
export const removeElementByPartialID = (tag, part_id) => {
    const query = tag + '[id^="' + part_id + '"]';
    const elements = document.querySelectorAll(query);
    const forEach = Array.prototype.forEach;
    forEach.call(elements, (d) => {
        d.parentNode.removeChild(d);
    });
};
export const removeElement = (element) => {
    return new Promise((resolve, reject) => {
        switch (Type.isElement(element) && Type.isElement(element?.parentNode)) {
            case true:
                element.parentNode.removeChild(element);
                resolve({ msg: 'Element removed', success: true });
                break;
            case false:
                resolve({ msg: 'Element removal failure', success: false, result: { element: element, parent: element?.parentNode } });
                break;
        }
        resolve({ msg: 'Element removed', success: true });
    });
};
export const selectListItemByValue = (list, value) => {
    for (let i = 0; i < list.options.length; i++) {
        if (list.options[i].value === value) {
            list.selectedIndex = i;
            break;
        }
    }
    return list.selectedIndex;
};
export const insertAfter = (element, referenceNode) => {
    referenceNode.parentNode.insertBefore(element, referenceNode.nextSibling);
};
export const insertBefore = (element, referenceNode) => {
    referenceNode.parentNode.insertBefore(element, referenceNode);
};
export const recreateNode = (element, withChildren = false) => {
    return new Promise((resolve, _reject) => {
        if (withChildren) {
            element?.parentNode?.replaceChild(element?.cloneNode(true), element);
        }
        else {
            const newElement = element?.cloneNode(false);
            while (element?.hasChildNodes()) {
                newElement?.appendChild(element?.firstChild);
            }
            element?.parentNode?.replaceChild(newElement, element);
        }
        resolve({ msg: 'Element replaced', success: true });
    });
};
export const domEvents = (element = document.body) => {
    const eventList = [];
    for (const key in element) {
        if (/\bon/.test(key)) {
            eventList.push(key);
        }
    }
    return eventList;
};
export const toggleElementVisibility = (element, isVisible, addClass, removeClass) => {
    if (Type.isElement(element)) {
        if (addClass)
            CSS.addClass(element, addClass);
        if (removeClass)
            CSS.removeClass(element, removeClass);
        element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }
};
export const getComposedPath = (domElement) => {
    const path = [];
    let currentElement = domElement;
    while (currentElement) {
        path.push(currentElement);
        currentElement = currentElement.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
        path.push(document);
    if (path.indexOf(window) === -1)
        path.push(window);
    return path;
};
export const isVTGElement = (element) => {
    if (Type.isElement(element)) {
        if (!Type.isEmpty(element?.className)
            &&
                element.className.split(' ').some((cssClass) => /vtgd-.*/.test(cssClass))) {
            return true;
        }
    }
    return false;
};
export const onDocumentReady = (callbackFunction) => {
    if (!Type.isFunction(callbackFunction))
        return;
    if (document.readyState !== 'loading') {
        callbackFunction();
    }
    else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', callbackFunction);
    }
    else {
        document['attachEvent']('onreadystatechange', function () {
            if (document.readyState === 'complete') {
                callbackFunction();
            }
        });
    }
};
export const getElementAdvanced = (obj) => {
    let element;
    if (Type.isEmpty(obj)) {
        element = undefined;
    }
    if (Type.isString(obj)) {
        element = document.querySelector(obj);
    }
    if (Type.isJQueryObject(obj)) {
        element = obj[0];
    }
    if (Type.isElement(obj)) {
        element = obj;
    }
    if (Type.isElement(element)) {
        return element;
    }
    return undefined;
};
export const disablePictureInPicture = (videoElement) => {
    if (Type.isElement(videoElement) && videoElement?.tagName === 'VIDEO') {
        videoElement.setAttribute('disablepictureinpicture', '');
    }
};
